import { Suspense, useContext, useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Box } from '@mui/material/';
import { ToolContext } from '../core/context/ToolContext';
import { WebRoute } from "../core/webrouter/bizRoute";
import { InstallPromotion } from './components/layouts/installation/InstallPromotion';
import { rqx } from '../core/request/API';
import { env } from '../core/Env';
import Lottie from 'react-lottie';
import AcadLoader from '../assets/json/AcadBizLogo_Loader_v2';
import moment from 'moment';
import { createActiveUser, getAllPersonalization, getDAU } from '../core/request/Global';
import { NotifProfession } from '../core/global/modal/Modal';

const sessionData = localStorage.getItem('pofacademy_biz_session');
const __SESSION = sessionData ? JSON.parse(sessionData) : null;
const tool_id =  process.env.REACT_APP_TID_BIZ;

export const Core = () => {
	const { tool_state, install_state, home_state, training_state, personalization_state } = useContext(ToolContext)
	const {provinces, cities, barangays} = tool_state
	const {openWelcome, setup} = personalization_state

	let uid = null;
    if (__SESSION && __SESSION.ainfo && __SESSION.ainfo.aid) {
        try {
            uid = window.atob(__SESSION.ainfo.aid).split('_').pop();
        } catch (error) {
            console.error("Error decoding user ID:", error);
        }
    }
	// console.log(window.atob(__SESSION.ainfo.aid))
	const __installer = () => {
		window.addEventListener('beforeinstallprompt', (e) => {
			e.preventDefault();
			install_state.prompt.set(e)
			installPromptHandler()
		});
	}

	const installPromptHandler = () => {
		setTimeout(() => {
		// install_state.ip.set({stat: true, prompt_type: 'first_prompt'})
		}, 2000);
	}
	const handleProceed = () => {
		tool_state.openPModal.set(false)
    	window.location.href = '/biz/professional';
	}

	const checkWalkthrough = async () => {
		if (!uid) return;

		const response = await getAllPersonalization({
			tool_id: parseInt(process.env.REACT_APP_TID_BIZ),
			user_id: uid,
			ref: 'all',
		});

		if (!Array.isArray(response) || response.length === 0) {
			openWelcome.set(true);
			return;
		}

		let personalization = [];
		try {
			personalization = JSON.parse(response[0].personalization);
		} catch (e) {
			console.error('Parse error', e);
			openWelcome.set(true);
			return;
		}

		const welcome = personalization.find(p => p.sf_name === 'welcome_admin');
		const homeTour = personalization.find(p => p.sf_name === 'home_tour');

		const welcomeDone = welcome?.status === 1;
		const homeTourDone = homeTour?.status === 1;

		if (!welcomeDone) {
			openWelcome.set(true);

			setup.set({
			...setup.data,
			home_tour: { stat: false, drawer: false }
			});

			return;
		}

		openWelcome.set(false);

		if (!homeTourDone) {
			setup.set({
			...setup.data,
			home_tour: { stat: true, drawer: false }
			});
			return;
		}

		setup.set({
			...setup.data,
			home_tour: { stat: false, drawer: false }
		});
	};



	
	useEffect(() => {
		const __init = async () => {
			const attempt = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/personalization/read`, {tool_id: process.env.REACT_APP_TID_BIZ, user_id: uid , ref: 'all'})
			// console.log(attempt)
			// RUN AN API REQUEST HERE ( SAMPLE REQUESTS BELOW: )
			let ainfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/account/read`, {aid: __SESSION.ainfo.aid})
			let pinfo = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/primeinfo/read`, {aid: __SESSION.ainfo.aid})
			let uaccess = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/roleaccess/uap`, {aid: __SESSION.ainfo.aid, tid:tool_id})
			let uaddress = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/assigned`, {aid:__SESSION.ainfo.aid})
			let getAllEmployees = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tooluser/gettooluser`, {company_id: uaccess[0].company_id, tool_id: process.env.REACT_APP_TID_BIZ})
			let getDept = await rqx.get(`<<biz>>/${env()}/general-maintenance/masterlist/department/getAllByCompanyId`, {company_id: uaccess[0].company_id})
			let getPostion = await rqx.get(`<<biz>>/${env()}/general-maintenance/masterlist/position/getAllByCompanyId`, {company_id: uaccess[0].company_id } )
			await tool_state.__SESSION.set({ainfo, pinfo, uaccess, uaddress})
			
			await createActiveUser({action:'signin',aid: __SESSION.ainfo.aid, date:moment(new Date()).format('YYYY-MM-DD'), tool_id:process.env.REACT_APP_TID_BIZ })
			let dau = await getDAU({tid: process.env.REACT_APP_TID_BIZ, platform:'Business', date:moment(new Date()).format('YYYY-MM-DD'), company_id:uaccess[0].company_id})
			home_state.dau.set({...home_state.dau.data,total:dau.active_user , external: 0, internal: dau.active_user})

			if (uaccess[0].company_id !== null) {
				const getAllUsers = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tooluser/gettooluser`, {company_id: uaccess[0].company_id, tool_id: process.env.REACT_APP_TID_BIZ})
				tool_state.toolUsers.set([...getAllUsers.superadmin, ...getAllUsers.users]);
			}
			
			// console.log(getAllEmployees)
			// console.log(getDept)
			// console.log(getPostion)
			// console.log(uaccess)
			// console.log(uid)
			// console.log(ainfo)
			// console.log(pinfo)

			let acd;
			let total;
			let uaction = await rqx.get(`<<tool>>/${env()==='local'?'dev':env()}/biz_dashboard/user_read_user_action`, {user_id: uid})
			
			if (uaction.acd.length > 0) { 
				acd = 1;
			} else {
				acd = 0;
			}

			total =  acd;
			home_state.userA.set({...home_state.userA.data, acd: acd, total: total})

			let newUploadTraining = await rqx.get(`<<tool>>/${env() === 'local' ? 'dev' : env()}/dashboard/new`)
			let newRecomendedTraining = await rqx.get(`<<tool>>/${env()}/dashboard/demand`)
			training_state.tnew.set(newUploadTraining)
			training_state.recommended.set(newRecomendedTraining)


			let cinfo = await rqx.get(`<<biz>>/${env()==='local'?'dev':env()}/general-maintenance/company/company-setup/getByCompanyId`, {company_id: uaccess[0].company_id})
			tool_state.cinfo.set(cinfo)
			let prof = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/profession/read`,{filter:'all'})
			let compileData = [...tool_state.profession.data, ...prof]
			tool_state.profession.set(compileData)

			tool_state.employee.set(getAllEmployees)
			tool_state.department.set(getDept)
			tool_state.position.set(getPostion)

			const p = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/province`, {ref:'id', filter: JSON.stringify([cinfo[0].province_id]) })
			const c = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/city`, {ref: 'id', filter: JSON.stringify([cinfo[0].city_id])})
			const b = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/location/barangay`, {ref: 'id', filter: JSON.stringify([cinfo[0].barangay_id])})
			provinces.set(p)
			cities.set(c)
			barangays.set(b)
			
			// SET STATES HERE ( SAMPLE STORING BELOW: )
			let d = new Date()
			d.setDate(d.getDate() + 30);
			localStorage.setItem('pofacademy_biz_session', JSON.stringify({expiration: `${d.getMonth()+1}${d.getUTCDate()}${d.getUTCFullYear()}`, ainfo: ainfo}))
			tool_state.userId.set(parseInt(window.atob(ainfo.aid).split('_')[1]))
			tool_state.prefetch.set(true)

			// RUN PWA INSTALLATION PROMPT HANDLER
			installPromptHandler()
		}
		
		if (__SESSION !== null) {
			__installer()
			__init()
		} else {
			setTimeout(() => {
				// SET STATES HERE ( SAMPLE STORING BELOW: )
				tool_state.prefetch.set(true)

				// RUN PWA INSTALLATION PROMPT HANDLER
				
				installPromptHandler()
			}, 1000);
		}
		tool_state.prefetch.set(false)
		console.log(`POFAcademy Business Version V1.1.38 is running`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (tool_state.userId.data) {
			checkWalkthrough();
		}
	}, [tool_state.userId.data]);

	const defaultOptions = {
		loop: true,
		autoplay: true, 
		animationData: AcadLoader,
		rendererSettings: {
		  preserveAspectRatio: 'xMidYMid slice'
		}
	};

	return (
		<Box width="100%" height="100%" >
			{
				tool_state.prefetch.data ? (
					<Router>
						<Suspense fallback={
							<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
								<Lottie options={defaultOptions} height={264} width={264} />
							</Box>
						}>
							<WebRoute />
						</Suspense>
					</Router>
				) : (
					<Box height="100%" width="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center">
						<Lottie options={defaultOptions} height={264} width={264} />
					</Box>
				)
			}
			<NotifProfession open={tool_state.openPModal.data} handleProceed={handleProceed} />
			<InstallPromotion install_state={install_state} __SESSION={__SESSION} home_state={home_state} />
		</Box>
	)
}